export default "__VITE_ASSET__CFUG6lG2__"